let spinnerVisible = false;
const spiner = document.querySelector('.js-spinner');
function showProgress() {
    if (!spiner) return;
    if (!spinnerVisible) {
        spiner.classList.add('spinner-show');
        spinnerVisible = true;
    }
}

function hideProgress() {
    if (!spiner) return;
    if (spinnerVisible) {
        spiner.classList.remove('spinner-show');
        spinnerVisible = false;
    }
}

export { showProgress, hideProgress };
